import React, { useEffect, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import GasPointsOverlayLayer from "../components/GasPointsOverlayLayer";

function useTransparentBody() {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const previous = {
      htmlBackground: html.style.background,
      htmlBackgroundImage: html.style.backgroundImage,
      bodyBackground: body.style.background,
      bodyBackgroundImage: body.style.backgroundImage,
      bodyMargin: body.style.margin,
      bodyOverflow: body.style.overflow,
    };

    html.style.background = "transparent";
    html.style.backgroundImage = "none";
    body.style.background = "transparent";
    body.style.backgroundImage = "none";
    body.style.margin = "0";
    body.style.overflow = "hidden";

    return () => {
      html.style.background = previous.htmlBackground;
      html.style.backgroundImage = previous.htmlBackgroundImage;
      body.style.background = previous.bodyBackground;
      body.style.backgroundImage = previous.bodyBackgroundImage;
      body.style.margin = previous.bodyMargin;
      body.style.overflow = previous.bodyOverflow;
    };
  }, []);
}

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, Number(value) || 0));
}

function normalizeChannelSlug(value) {
  const raw = String(value || "").trim().toLowerCase();
  const parts = raw.split(":");
  return String(parts[parts.length - 1] || "")
    .replace(/[^a-z0-9_-]/g, "")
    .slice(0, 80);
}

export default function OverlayGasPoints() {
  const { channelId } = useParams();
  const [searchParams] = useSearchParams();
  const channelSlug = normalizeChannelSlug(channelId);
  const debug = searchParams.get("debug") === "1";
  const volume = clamp(searchParams.get("volume") || 1, 0, 1.5);
  const scale = clamp(searchParams.get("scale") || 1, 0.65, 1.4);

  useTransparentBody();

  const room = useMemo(
    () => (channelSlug ? `live:${channelSlug}` : ""),
    [channelSlug]
  );

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        background: "transparent",
        transform: `scale(${scale})`,
        transformOrigin: "center",
      }}
    >
      <GasPointsOverlayLayer
        room={room}
        soundEnabled
        alertVolume={volume}
        debug={debug}
      />
    </div>
  );
}
